import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { AlertService, AuthService } from "@standard/services";
import { BoxContainerUnauthen } from "@standard/components/BoxContainer";
import { useState } from "react";

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const history = useHistory();

  const { register, handleSubmit } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);

    AuthService.forgetPassword(data.email)
      .then(() => {
        setIsLoading(false);
        AlertService.done(
          "Your password was reset, please check your email"
        ).then(() => history.push("login"));
      })
      .catch((errors) => {
        setIsLoading(false);
        setErrors(errors);
      });
  };

  return (
    <BoxContainerUnauthen
      isLoading={isLoading}
      errors={errors}
      title="Forgot password"
      description="Enter your email address and your password will be reset and emailed
    to you."
    >
      <form className="m-t" id="form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group col-6 mx-auto">
          <input
            type="email"
            className="form-control"
            placeholder="Email address"
            name="email"
            {...register("email")}
            required=""
          />
        </div>
        <div className="form-group col-6 mx-auto">
          <button
            type="submit"
            className="btn btn-primary block full-width m-b"
          >
            Send new password
          </button>
        </div>
        <div className="form-group col-6 mx-auto text-right">
          <small>
            <Link to="/login">Go to login</Link>
          </small>
        </div>
      </form>
    </BoxContainerUnauthen>
  );
};

export default ForgotPassword;
